module.exports = __webpack_public_path__ + "static/media/12.fe2f03ac.jpg";